import { initThemeTransition } from './Effects/themeTransition'
import { initYakinikuUtilities } from './Utils'

export { initThemeTransition } from './Effects/themeTransition'
export { initYakinikuUtilities, normalizeClassString } from './Utils'

export function initializeYakinikuCore() {
	const cleanupUtilities = initYakinikuUtilities()
	const cleanupThemeTransition = initThemeTransition()

	return () => {
		cleanupThemeTransition()
		cleanupUtilities()
	}
}

export { Box } from './Components/Box'
export { Button } from './Components/Button'
export { Checkbox } from './Components/Checkbox'
export { Icon } from './Components/Icon'
export { IconButton } from './Components/IconButton'
export { Input } from './Components/Input'
export { Loading } from './Components/Loading'
export { Textarea } from './Components/Textarea'
export { initSpatialNav } from './Navigation/spatialNav'
